module.exports = __webpack_public_path__ + "img/gongshui-4.c9c950ae.png";